export function getCountryFromBrowser(): string {
  try {
    const lang = navigator.language || (navigator as unknown as { userLanguage?: string }).userLanguage;
    if (lang && lang.includes('-')) {
      return lang.split('-')[1].toUpperCase();
    }
    return 'US';
  } catch (e) {
    return 'US';
  }
}
